import { OptionType } from 'components/Pages/MessagesPage/GroupMessages/constants'
import { S3FileTypeEnum } from 'constants/aws'
import { IProcessWithRelations } from 'interfaces/process'
import { IStepWithRelations } from 'interfaces/step'
import { IUser } from '../user'

export interface IMessageGroup {
  thread: IMessageGroupThreads
  groups: {
    name: string
  }[]
  users?: IUser[]
  isSeen: boolean
  organizationId?: number
  sentDate?: any
  name?: string
}

export interface IMessageGroupThreads {
  id: number
  name?: string
  lastMessageAt: Date
  organizationId: number
  groups: {
    name: string
  }[]
  users?: IUser[]
  groupMessages: IGroupMessages[]
  groupMessageThreadUserSeens: IGroupMessageThreadUserSeen[]
  isSeen: boolean
  createdAt: Date
}

export interface IGroupMessages {
  createdAt: Date
  updatedAt: Date
  id: number
  content: string
  attachments?: { name: string; type: S3FileTypeEnum }[]
  groupThreadId: number
  userId: number
  user: IUser
  receiverId: number
  receiver: IUser
}

export interface IThreadGroup {
  name?: string
  organizationId: number
  userId: number
  receiverId: number
  content: string
  attachments?: { name: string; type: S3FileTypeEnum }[]
  isPrivate?: boolean
}

export interface ISelectMember {
  members: IThreadMember[]
}

export interface IThreadMember {
  label?: string
  value: number
  type?: OptionType
}

export interface ISupportMessage {
  id: number
  attachments?: { name: string; type: S3FileTypeEnum }[]
  content?: string
  userId: number
  supportThreadId: number
  createdAt: Date
  user: IUser
}

export interface ISupportThreadDto {
  isSeen: boolean
  thread: ISupportMessageThread
}

export interface ISupportMessageThread {
  id: number
  name?: string
  subject?: string
  lastMessageAt: Date
  status: SupportMessageThreadStatus
  step?: IStepWithRelations
  process?: IProcessWithRelations
  organizationId: number
  supportMessages: ISupportMessage[]
  users?: IUser[]
  stepId?: number
  processId?: number
  claimedBy?: number | null
  createdAt: Date
  supportMessage: ISupportMessage
}

export enum SupportMessageThreadStatus {
  ALL = 0,
  UNCLAIMED = 1,
  CLAIMED = 2,
  RESOLVED = 3,
  UNREAD = 4 // INFO: For FE filter only
}

export interface ICreateSupportMessageThread {
  stepId?: number
  processId?: number
  organizationId: number
  userId: number
  content: string
  subject?: string
  attachments?: { name: string; type: string }[]
}

export interface ISupportMessageThreadStatusHistory {
  id: number
  userId: number
  threadId: number
  status: SupportMessageThreadStatus
  createdAt: Date
  updatedAt: Date
  user?: IUser
}

export interface IGroupMessageThreadUserSeen {
  userId: number
  groupThreadId: number
  lastSeenAt: Date
}

export interface IMessageAttachment {
  name: string
  type: string
}
